import React from 'react'
import Link from 'gatsby-link'
import { Helmet } from "react-helmet";

import Block from '../components/block';
import Title from '../components/my-title';

import BlockCover from '../components/block-cover';
import BlockContentBeautiful from '../components/block-content-beautiful';

import BlockReassurance from '../components/block-reassurance';

import AtelierImage from '../assets/atelier.jpg';
import AnsImage from '../assets/30-ans.png';
import AnsBackgroundImage from '../assets/30-ans-background.jpg';

import DidierBreImage from '../assets/didier-bre.png';
import ArrowWhiteImage from '../assets/arrow-white.svg';

const data = [
  {
    name: 'Jean Pierre',
    title: (
      <p>Menuisier d'Agencement,<br />(Atelier, Chantier, Pose)</p>
    ),
    avatarUrl: '/teams/PHOTO TEAM-04.png'
  },
  {
    name: 'Hervé',
    title: (
      <p>Menuisier d'Agencement<br />Responsable Chantier<br />Pose, deviseur</p>
    ),
    avatarUrl: '/teams/PHOTO TEAM-01.png'
  },
  {
    name: 'Christophe',
    title: (
      <p>Menuisier d'Agencement<br />(Atelier, Chantier, Pose)</p>
    ),
    avatarUrl: '/teams/PHOTO TEAM-06.png'
  },
  {
    name: 'Anna',
    title: (
      <p>Responsable Administratif et Financier</p>
    ),
    avatarUrl: '/teams/Anna.png'
  },
  {
    name: 'Valentin',
    title: (
      <p>Menuisier d'Agencement<br />(Atelier, Chantier, Pose)</p>
    ),
    avatarUrl: '/teams/PHOTO TEAM-05.png'
  },
  {
    name: 'Florent',
    title: (
      <p>Menuisier d'Agencement<br />(Atelier, Chantier, Pose)</p>
    ),
    avatarUrl: '/teams/PHOTO TEAM-03.png'
  },
]

const BlockWood = ({ title, imageUrl, height }) => (
  <div className="block-wood mb-3 mt-3" style={Object.assign(
    imageUrl ? {
      backgroundImage: `url(${imageUrl})`
    } : {},
    height ? {
      height: height
    } : {}
  )}>
    <div className="block-wood-title-container">
      <p className="block-wood-title mb-0">{title}</p>
    </div>
  </div>
)

const Atelier = () => (
  <div>
    <Helmet>
      <title>Atelier de menuiserie sur mesure à La-Celle-Saint-Cloud - 92</title>
      <meta name="description" content="Fabrication sur mesure en bois ou panneaux de particules : noyer US, plaqué chêne ou massif, plaqué hêtre ou massif, sapin massif, …" />
    </Helmet>
    <BlockCover
      backgroundUrl={AtelierImage}
      title="L'atelier"
      repeatedTitle={true} />

    <BlockContentBeautiful
      hasDecoration
      backgroundStyle={{
        backgroundImage: `url(${AnsBackgroundImage})`
      }}
      decorationImage={AnsImage}
      contentCol={7}>
      <h2 className="fs-27 lh-32 color-red light">Le bois dans tous ses états.</h2>
      <p className="color-grey fs-16 light lh-23">
        Bibliothèques, parquets, terrasses, cuisines, placards, dressings, portes, meubles, étagères, mezzanines, éléments de décoration, salles de bain… Le bois prend toutes les formes que vous souhaitez entre les mains expertes de Didier Bré. Il vous propose ses services pour concrétiser toutes vos idées, avec une fabrication sur mesure en bois ou panneaux de particules. Il travaille également en partenariat avec des entreprises certifiées, plombiers, électriciens, peintres, plaquistes, qui réalisent toutes les prestations complémentaires de haute qualité dont votre projet a besoin, dans Paris et l’Ouest parisien.
      </p>
    </BlockContentBeautiful>

    <BlockContentBeautiful
      backgroundStyle={{
        backgroundColor: `#000000`
      }}
      decorationImage={DidierBreImage}
      contentCol={8}
      reverse>
      <h2 className="fs-27 lh-32 color-red light">Didier Bré, Artisan Menuisier</h2>
      <p className="color-light-grey fs-16 light lh-23 mb-5">
        Fort d'une expérience de plus de 30 ans dans les métiers de la menuiserie, Didier Bré est un professionnel reconnu, passionné par son métier et amoureux du bois sous toutes ses formes.<br /> Enthousiaste, réceptif, disponible, Didier est toujours prêt à relever les challenges pour s’adapter à vos exigences. Entouré d’une solide équipe au sein de l’entreprise qu’il a créée, il met toute son énergie et son talent au service des projets qui lui sont confiés.<br />
        Comme les grands architectes avec qui il élabore régulièrement des projets ambitieux, vous apprécierez son savoir-faire et la qualité de son travail.
      </p>
      <div className="row">
        <div className="col-12 col-md-3">
          <p className="color-red light fs-22 lh-27">
            Didier<br />
            <strong>BRÉ</strong>
          </p>
          <p className="color-white light fs-15">
            Menuisier<br />
            d'Agencement,<br />
            Gérant de l'entreprise
          </p>
        </div>
        <div className="col-6 col-sm-4 col-md-3 mb-4">
          <Link to="/expertise" className="block-atelier">
            <div className="block-atelier-background">
              <img className="w-100 img-fluid" src="/atelier-expertise.jpg" role="presentation" />
            </div>
            <div className="block-atelier-foreground">
              <p>Nos expertises <img src={ArrowWhiteImage} role="presentation" /></p>
            </div>
          </Link>
        </div>
        <div className="col-6 col-sm-4 col-md-3 mb-4">
          <Link to="/realisations" className="block-atelier">
            <div className="block-atelier-background">
              <img className="w-100 img-fluid" src="/atelier-realisation.jpg" role="presentation" />
            </div>
            <div className="block-atelier-foreground">
              <p>Nos réalisations <img src={ArrowWhiteImage} role="presentation" /></p>
            </div>
          </Link>
        </div>
        <div className="col-6 col-sm-4 col-md-3 mb-4">
          <Link to="/contact" className="block-atelier">
            <div className="block-atelier-background">
              <img className="w-100 img-fluid" src="/atelier-contact.jpg" role="presentation" />
            </div>
            <div className="block-atelier-foreground">
              <p>Contactez-nous <img src={ArrowWhiteImage} role="presentation" /></p>
            </div>
          </Link>
        </div>
      </div>
    </BlockContentBeautiful>

    <Block hasDecoration id="l-equipe" className="d-none d-md-block">
      <Title>L'équipe</Title>

      <div className="row justify-content-center team-list">
        {data.map(item => (
          <div className="col-12 col-md-6 col-lg-4 col-xl-4 team-item-container">
            <div className="team-item mb-5">
              <img className="w-100 img-fluid team-item-image" src={item.avatarUrl} alt={item.name} />
              <div className="team-item-content">
                <p className="team-item-name mb-1 bold color-red fs-22 fh-27">
                  {item.name}
                </p>
                <div className="team-item-title mb-0 light fs-15 color-white lh-23">
                  {item.title}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Block>

    <Block hasDecoration backgroundColor="#EFF2F4">
      <Title>Les principaux bois que nous utilisons</Title>

      <div className="block-woods">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <BlockWood
                title="Noyer US"
                imageUrl="/woods/noyer-us.jpg"
              />
            </div>
            <div className="col-md-5">
              <BlockWood
                title="Panneaux à peindre medium"
                imageUrl="/woods/panneaux.jpg"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <BlockWood
                title="plaqué Hêtre / hêtre Massif"
                imageUrl="/woods/plaque.jpg"
                height="530"
              />
            </div>
            <div className="col-md-7">
              <div className="row">
                <div className="col-md-12">
                  <BlockWood
                    title="Plaqué Chêne / Chêne Massif"
                    imageUrl="/woods/chene.jpg"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <BlockWood
                    title="Sapin massif"
                    imageUrl="/woods/sapin.jpg"
                  />
                </div>
                <div className="col-md-6">
                  <BlockWood
                    title="Panneaux particules"
                    imageUrl="/woods/panneaux-particule.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Block>

    <Block backgroundUrl="/dorelys-smits-200737.jpg">
      <div className="row">
        <div className="col-12">
          <p className="fs-31 lh-40 ls-21 light color-white mb-0">
            L'équipe utilise les bois et les essences<br />
            les mieux adaptées à votre projet,<br />
            <strong>dans le respect le plus strict des traditions menuisières</strong>
          </p>
        </div>
      </div>
    </Block>

    <BlockReassurance hasDecoration={false} />
  </div>
)

export default Atelier



// WEBPACK FOOTER //
// ./src/pages/atelier.js